import { useSyncExternalStore } from "react";

const STORAGE_KEY = "sj-monaco-theme-variant";
const CHANGE_EVENT = "sj-monaco-theme-variant-change";

export type MonacoThemeVariant = "default" | "github";
const DEFAULT_VARIANT: MonacoThemeVariant = "default";

export const MONACO_THEME_VARIANTS: { label: string; value: MonacoThemeVariant }[] = [
  { label: "Default", value: "default" },
  { label: "High Contrast", value: "github" },
];

const getSnapshot = (): MonacoThemeVariant => {
  try {
    const storedVariant = localStorage.getItem(STORAGE_KEY);

    if (storedVariant === "default" || storedVariant === "github") {
      return storedVariant;
    }
  } catch {
    return DEFAULT_VARIANT;
  }

  return DEFAULT_VARIANT;
};
const getServerSnapshot = (): MonacoThemeVariant => DEFAULT_VARIANT;

const subscribe = (callback: () => void) => {
  const handleStorageChange = (event: StorageEvent) => {
    if (event.storageArea === localStorage && event.key === STORAGE_KEY) {
      callback();
    }
  };

  window.addEventListener(CHANGE_EVENT, callback);
  window.addEventListener("storage", handleStorageChange);
  return () => {
    window.removeEventListener(CHANGE_EVENT, callback);
    window.removeEventListener("storage", handleStorageChange);
  };
};

export const useMonacoThemeVariant = () => {
  const variant = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);

  const setVariant = (newVariant: MonacoThemeVariant) => {
    try {
      localStorage.setItem(STORAGE_KEY, newVariant);
      window.dispatchEvent(new Event(CHANGE_EVENT));
    } catch {
      // Ignore storage write failures so UI interactions do not throw in restricted browser contexts.
    }
  };

  return { variant, setVariant };
};
